import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/admin/map-editor/map-editor.component.ngfactory.ts